import { Info, Pencil, Trash2 } from 'lucide-react';

import EmptyButton from 'ud-ui/components/empty-button';
import { Notification } from 'modules/core/domain/interfaces/supabase/notifications/types';
import React from 'react';
import UDChip from 'ud-ui/components/chip';
import UDText from 'ud-ui/components/text';
import UDTippy from 'ud-ui/components/tippy';
import { theme } from 'styles/theme/theme';
import { useTranslation } from 'react-i18next';
import { typeColorMap, typeIconMap } from 'modules/notifications/domain/const';

interface Props {
  notification: Notification;
  isNew?: boolean;
  allowChange?: boolean;
  onEdit?: (n: Notification) => void;
  onDelete?: (id: number) => void;
}

const NotificationComponent: React.FC<Props> = ({ notification, isNew, allowChange, onEdit, onDelete }) => {
  const { t } = useTranslation();
  const Icon = typeIconMap[notification.type] || Info;
  const color = typeColorMap[notification.type] || theme.colors.Gray;
  const date = new Date(notification.createdAt);
  const dateStr = date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: '2-digit' });
  const timeStr = date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });

  return (
    <div className="position-relative flex items-start gap-4 border-b border-[#e5e7eb] py-4">
      <div className="flex shrink-0 flex-col items-center" style={{ width: 32 }}>
        <UDTippy content={t(`notificationType.${notification.type}`)}>
          <div className="flex items-center justify-center" style={{ width: 32, height: 32, background: color, borderRadius: 8 }}>
            <Icon size={20} color={theme.colors.SurfaceWhite} />
          </div>
        </UDTippy>
        {isNew && <UDChip color="yellow" size={10} className="mt-2" aria-label="Новое" />}
      </div>
      <div className="grow">
        <div className="mb-2 flex items-center gap-2">
          <UDText type="subhead" className="bold">
            {notification.title}
          </UDText>
          <UDText type="caption-1" className="ml-4" style={{ color: theme.colors.Gray }}>
            {dateStr} {timeStr}
          </UDText>
          {allowChange && (
            <div className="ml-4 flex items-end gap-2">
              <EmptyButton className="cursor-pointer" aria-label="Редактировать" onClick={() => onEdit?.(notification)}>
                <Pencil size={18} />
              </EmptyButton>
              <EmptyButton
                color={theme.colors.CaseError}
                className="cursor-pointer"
                aria-label="Удалить"
                onClick={() => onDelete?.(notification.id)}
              >
                <Trash2 size={18} />
              </EmptyButton>
            </div>
          )}
        </div>
        <UDText type="subhead" style={{ color: theme.colors.DarkBlue, whiteSpace: 'pre-line' }}>
          {notification.text}
        </UDText>
      </div>
    </div>
  );
};

export default NotificationComponent;
